/**
 * Created by Ivan on 30.01.2026
 */

let SoftFeastMissionWindow;

switch (cleverapps.config.ui) {
    case "riddles":
        SoftFeastMissionWindow = RiddlesSoftFeastWindow;
        break;
    case "wooden":
        SoftFeastMissionWindow = WoodenSoftFeastWindow;
        break;
    case "tropical":
        SoftFeastMissionWindow = TropicalSoftFeastWindow;
        break;
    case "heroes":
        SoftFeastMissionWindow = HeroesSoftFeastWindow;
}